import { getMiddleware } from '../ws';

export default getMiddleware();
